export default "__VITE_ASSET__YHviP4YE__"